import { RootState } from 'src/state/reducer';
import { createSelector } from 'reselect';
import { ZoomCardState } from 'src/state/zoom-card/zoomCardReducer';

export const zoomCardStateSelector = (state: RootState) => state.zoomCard;

export const zoomCardClosedSelector = createSelector(
  zoomCardStateSelector,
  (state: ZoomCardState) => state.closed,
);
